import { getErrorMessage } from "@lib/errors";
import { Component, type ReactNode } from "react";
import { ErrorFallback } from "./ErrorFallback";

type RootErrorBoundaryProps = {
  children: ReactNode;
};

type RootErrorBoundaryState = {
  error: unknown;
};

export class RootErrorBoundary extends Component<
  RootErrorBoundaryProps,
  RootErrorBoundaryState
> {
  state: RootErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: unknown): RootErrorBoundaryState {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorFallback
          className="h-screen"
          message={getErrorMessage(this.state.error)}
          actions={[
            {
              label: "Reload page",
              onClick: () => window.location.reload(),
            },
          ]}
        />
      );
    }

    return this.props.children;
  }
}
